import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ChangeControlConstants } from '../../constants/changeControlConstants';

@Component({
  selector: 'app-change-control-target-completion-date-modal',
  templateUrl: './change-control-target-completion-date-modal.component.html',
  styleUrls: ['./change-control-target-completion-date-modal.component.scss'],
})
export class ChangeControlTargetCompletionDateModalComponent {
  @Input() targetCompletionDateForCC!: Date | null;
  @Output() targetCompletionDateToSave = new EventEmitter<Date | null>();
  @Output() closeTargetCompletionDateModal = new EventEmitter<boolean>();
  errorMessage: string = '';
  minDateValue: Date = new Date();
  targetCompletionDate: Date | null = new Date();
  display: boolean = false;

  constructor() {}

  ngOnInit(): void {
    this.showTargetCompletionDateModal();
  }

  closeTargetCompletionDate = () => {
    this.display = false;
    this.closeTargetCompletionDateModal.emit(true);
  };
  showTargetCompletionDateModal = () => {
    this.targetCompletionDate =
      this.targetCompletionDateForCC &&
      this.targetCompletionDateForCC < this.minDateValue
        ? null
        : new Date(this.targetCompletionDateForCC as Date);
    this.display = true;
  };
  saveTargetCompletionDate = () => {
    if (this.targetCompletionDate == null) {
      this.errorMessage =
        ChangeControlConstants.ChangeControl_TargetCompletionDate_Required;
    } else {
      this.display = false;
      this.targetCompletionDateToSave.emit(this.targetCompletionDate);
    }
  };
}
